import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, Spin } from 'antd';
import { hasPrivilege } from '../api/token';
import { withLocale } from '../l10n';
import LibrariesList from '../components/LibrariesList';
import { useGetCloudKeyQuery } from '../services/lookupApi';
import { USER_UUID } from '../utils/constants';

function Translator({ lang }) {
  const navigate = useNavigate();
  const translator_view = hasPrivilege('translator_view');

  const userUuid = localStorage.getItem(USER_UUID);
  const { isLoading } = useGetCloudKeyQuery(userUuid, { skip: !userUuid });

  useEffect(() => {
    if (!translator_view) {
      navigate("/");
    }
  }, [navigate, translator_view])

  const items = [
    { label: lang.handle('Librerías'), key: 'libraries', children: <LibrariesList type="libraries" /> },
    { label: lang.handle('Plantillas'), key: 'templates', children: <LibrariesList type="templates" /> },
  ]

  if (translator_view) {
    if (isLoading) return <Spin />;

    return (
      <Tabs type="card" defaultActiveKey="libraries" items={items} />
    )
  }
}

export default withLocale(Translator);
